import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'eq-ui-success-message',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './success-message.component.html',
  styleUrl: './success-message.component.scss',
})
export class SuccessMessageComponent {

  @Input() header: string = 'Success!';
  @Input() title: string = 'Succesfully work is done';
  @Input() subtitle?: string;
  @Input() confirmLabel?: string;
  @Output() confirmEvent: EventEmitter<void> = new EventEmitter<void>();
  
  confirm() {
    this.confirmEvent.emit();
  }
}
